import { jsx as _jsx } from "react/jsx-runtime";
import { InsulinAdministrationProvider, InsulinWidget, Spinner, } from "@madmedical/ui";
import { usePatientId } from "@madmedical/user";
import { invariant } from "@madmedical/utils";
import { useGetInsulinAdministrationRangeQuery } from "../api";
import adaptAdministration from "../adaptAdministration";
export const InsulinDashboardWidget = () => {
    const { patientId } = usePatientId();
    const { data, isLoading } = useGetInsulinAdministrationRangeQuery({
        patientId,
    });
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    invariant(data);
    return (_jsx(InsulinAdministrationProvider, Object.assign({ value: {
            bloodSugareAverages: {},
            products: [],
            administrations: data.map(adaptAdministration),
        } }, { children: _jsx(InsulinWidget, {}) })));
};
